import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { formatMontant } from 'utils/numberToWordsFr';
import { toastApiErrors } from 'utils/toastApiError';
import { useGetComptePaiementQuery } from 'actions/compte_paiement/queries';
import { usePayerFactureMutation } from 'actions/facturation/mutations';
import 'utils/ConfirmationModal.css';
import './facturation.css';

if (typeof window !== 'undefined') {
  Modal.setAppElement('#root');
}

export default function PayFactureModal({ facture, show, onHide }) {
  const { clientID: dossier_id } = useParams();
  const { data: comptes } = useGetComptePaiementQuery({ dossier_id });
  const [payerFacture, { isLoading }] = usePayerFactureMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [montant, setMontant] = useState('');
  const [compteId, setCompteId] = useState('');
  const [datePaiement, setDatePaiement] = useState(new Date().toISOString().slice(0, 10));

  useEffect(() => {
    if (facture) {
      const reste = (facture.net_a_payer || 0) - (facture.montant_paye || 0);
      setMontant(reste > 0 ? reste : facture.net_a_payer || '');
      setCompteId('');
      setDatePaiement(new Date().toISOString().slice(0, 10));
    }
  }, [facture]);

  const submit = async (e) => {
    e.preventDefault();
    if (isSubmitting || isLoading) return;
    setIsSubmitting(true);
    try {
      await payerFacture({
        id: facture.id,
        montant: parseInt(montant) || null,
        compte_paiement_id: compteId ? parseInt(compteId) : null,
        date_paiement: datePaiement,
      }).unwrap();
      toast.success(`Règlement enregistré sur ${facture.numero}`);
      onHide();
    } catch (err) {
      toastApiErrors(err);
    } finally {
      setIsSubmitting(false);
    }
  };


  const reste = facture ? (facture.net_a_payer || 0) - (facture.montant_paye || 0) : 0;

  return (
    <Modal
      isOpen={show}
      onRequestClose={onHide}
      contentLabel="Encaisser la facture"
      className="Modal pay-modal"
      overlayClassName="Overlay"
    >
      <h2>Encaisser {facture?.numero}</h2>
      {facture?.client_nom_complet && (
        <p className="text-muted" style={{ marginBottom: 4, fontSize: '13px' }}>
          Client : {facture.client_nom_complet}
        </p>
      )}
      <p>
        Net à payer : <b>{formatMontant(facture?.net_a_payer)} FCFA</b>
        {facture?.montant_paye > 0 && (
          <> : Reste : <b>{formatMontant(reste)} FCFA</b></>
        )}
      </p>
      <Form onSubmit={submit}>
        <Form.Group className="mb-3">
          <Form.Label>Montant encaissé</Form.Label>
          <Form.Control
            type="number"
            min="1"
            required
            value={montant}
            onChange={(e) => setMontant(e.target.value)}
            className="rounded rounded-pill"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Compte de réception</Form.Label>
          <Form.Select
            value={compteId}
            onChange={(e) => setCompteId(e.target.value)}
            className="rounded rounded-pill"
          >
            <option value="">Caisse (par défaut)</option>
            {comptes?.data?.map((c) => (
              <option key={c.id} value={c.id}>
                {c.compte} : {c.source_paiement} (Solde : {formatMontant(c.solde_comptable ?? c.montant_restant ?? 0)} F)
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <div className="fact-pay-info">
          L&apos;enregistrement passera la facture en « Payé » si elle est soldée,
          créditera le compte sélectionné et créera automatiquement l&apos;écriture
          de trésorerie correspondante.
        </div>
        <Form.Group className="mb-3">
          <Form.Label>Date du règlement</Form.Label>
          <Form.Control
            type="date"
            required
            value={datePaiement}
            onChange={(e) => setDatePaiement(e.target.value)}
            className="rounded rounded-pill"
          />
        </Form.Group>
        <div className="pay-modal-actions">
          <button type="button" onClick={onHide} className="btn btn-danger" disabled={isLoading}>
            Annuler
          </button>
          <button
            type="submit"
            className="btn btn-primary d-inline-flex align-items-center"
            style={{ backgroundColor: '#068f7a', borderColor: '#068f7a' }}
            disabled={isLoading || isSubmitting}
          >
            {(isLoading || isSubmitting) && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
            )}
            {isLoading || isSubmitting ? 'Enregistrement…' : 'Enregistrer le règlement'}
          </button>

        </div>
      </Form>
    </Modal>
  );
}
